import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import { getCurrentInstance, ref, watch } from "vue";
import { useRoute } from "vue-router";
export default {
  __name: 'App',
  setup: function setup(__props) {
    var instance = getCurrentInstance();
    var route = useRoute();
    var navHeight = ref(0);
    var whiteList = ["/envList"];
    watch(function () {
      return route.path;
    }, function (path) {
      if (!whiteList.includes(path) && window.deviceInfo) {
        console.log("状态栏高度>>>>", window.deviceInfo.statusBarHeight);
        navHeight.value = window.deviceInfo.statusBarHeight;
      } else {
        navHeight.value = 0;
      }
    }, {
      immediate: true
    });

    // onMounted(() => {
    //   instance.proxy.$xsyxBridge.shouldBlockPopGesture({ isBlock: true });
    //   instance.proxy.$xsyxBridge.onBackClick({
    //     success: () => {
    //       if (["/home", "/iframe"].includes(route.path)) {
    //         instance.proxy.$xsyxBridge.goBack();
    //       }
    //     },
    //   });
    // });

    window.vue = instance.proxy;
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view, null, {
        default: _withCtx(function (_ref) {
          var Component = _ref.Component;
          return [_createElementVNode("div", {
            style: _normalizeStyle({
              width: '100%',
              height: navHeight.value + 'px',
              background: 'white'
            })
          }, null, 4), (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))];
        }),
        _: 1
      });
    };
  }
};